import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-file-image-fill",
  "use": "rt-portal-file-image-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-file-image-fill\">\r\n<path d=\"M854.6,288.7L639.4,73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7,0-32,14.3-32,32v832c0,17.7,14.3,32,32,32h640\r\n\tc17.7,0,32-14.3,32-32V311.3C864,302.8,860.6,294.7,854.6,288.7z M400,402c22.1,0,40,17.9,40,40s-17.9,40-40,40s-40-17.9-40-40\r\n\tS377.9,402,400,402z M696,696H328c-6.7,0-10.4-7.7-6.3-12.9l99.8-127.2c3.2-4.1,9.4-4.1,12.6,0l41.1,52.4l77.8-99.2\r\n\tc3.2-4.1,9.4-4.1,12.6,0l136.5,174C706.4,688.3,702.6,696,696,696z M602,326V137.8L790.2,326H602z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/file-image-fill.svg
// module id = 1846
// module chunks = 137